import { render, staticRenderFns } from "./OrderTracking.vue?vue&type=template&id=5e3a5b4e&"
import script from "./OrderTracking.vue?vue&type=script&lang=js&"
export * from "./OrderTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports